import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.vehicles')
  .factory('$vehicles', vehiclesObjectFactory);

/* @ngInject */
function vehiclesObjectFactory($bringozFactory: $bringozFactory,
                               vehiclesAPI: BringozApi,
                               Vehicles_DS: DataStoreConfig) {
  function $vehicles(id: string) {
    return $bringozFactory(id, vehiclesAPI, Vehicles_DS)
  }

  return $vehicles
}
